// extracted by mini-css-extract-plugin
export default {"paginator":"StoryMenu__paginator--1MITq"};